<template>
  <form @submit.prevent="checkToken">
    <p>
      ITC Compliance Ltd, who regulate us for some financial service activity created a unique
      online customer portal to provide you with and store your important compliance information
      and documentation.
    </p>
    <p>
      You should have been given a registration token either by your dealer or via an email. Please
      enter it here. If you do not know this code please contact your dealer who will be able to
      provide it.
    </p>

    <div
      v-for="(row, rowKey) in registrationToken.rows"
      :key="rowKey"
      class="row"
    >
      <component
        :is="editing ? `${field.type}-field` : 'span-field'"
        v-for="(field, key) in row"
        :key="`field${key}`"
        v-model="registrationToken[key]"
        :name="key"
        :validation="field.validation"
        v-bind="field"
        :data-vv-scope="'registrationToken'"
      />
    </div>

    <input
      v-if="editing"
      type="submit"
      class="btn btn-primary pull-right"
      value="Next"
    >
  </form>
</template>

<script>
import _ from 'lodash';
import RegistrationTokenModel from '../../../models/registrationToken';
import DateField from '../../partials/field/date.vue';
import SelectField from '../../partials/field/select.vue';
import SpanField from '../../partials/field/span.vue';
import TextField from '../../partials/field/text.vue';
import TelephoneField from '../../partials/field/telephone.vue';
import PasswordField from '../../partials/field/password.vue';
import recaptchaMixin from '../../../mixins/recaptcha';

export default {
  components: {
    DateField,
    SelectField,
    SpanField,
    TelephoneField,
    TextField,
    PasswordField,
  },
  mixins: [recaptchaMixin],
  props: {
    groupSlug: {
      type: String,
      default: 'default',
    },
    editing: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const tokenModel = new RegistrationTokenModel();
    tokenModel.setDealerSlug(this.groupSlug);

    return {
      registrationToken: tokenModel,
      generalErrors: [],
    };
  },
  methods: {
    checkToken() {
      this.$validator.errors.clear();
      const app = this;
      app.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            window.grecaptcha.enterprise.execute(this.siteKey, { action: 'register' })
              .then((token) => {
                this.registrationToken.setRecaptchaToken(token);
                this.registrationToken.check()
                  .then(this.redirectToRegisterForm)
                  .catch((errors) => {
                    this.generalErrors = errors.general;
                    _.each(errors, (errs, key) => {
                      this.$validator.errors.add(`form-field-${key}`, errs[0]);
                    });
                  });
              })
              .catch(() => {});
          }
        });
    },
    redirectToRegisterForm() {
      const url = `/${this.groupSlug}/register?token=${this.registrationToken.registration_token}`;
      window.location.href = url;
    },
  },
};
</script>
